export default "__VITE_ASSET__UKzXDS7J__"